"use strict";

(function(z, Backbone){

    var ProjectsCorporateContractsModel = Backbone.Model.extend({
        urlRoot: "/api/corporateContracts",
        validation: {
            name: [{
                required: true,
                msg: Translator.trans("js.error_message_contractsform_name_required")
            },{
                minLength: 4,
                msg: Translator.trans("js.error_message_orderform_customer_name_minlength")
            }],
            // position: [{
            //     required: true,
            //     msg: Translator.trans("js.error_message_representativeform_position_required")
            // },{
            //     minLength: 4,
            //     msg: Translator.trans("js.error_message_representativeform_position_minlength")
            // },{
            //     maxLength: 64,
            //     msg: Translator.trans("js.error_message_representativeform_position_maxlength")
            // }],
            // phoneNumber: [{
            //     required: true,
            //     msg: Translator.trans("js.error_message_representativeform_phoneNumber_required")
            // },{
            //     minLength: 10,
            //     msg: Translator.trans("js.error_message_representativeform_phoneNumber_minlength")
            // },{
            //     maxLength: 16,
            //     msg: Translator.trans("js.error_message_representativeform_phoneNumber_maxlength")
            // }, {
            //     pattern: "digits",
            //     msg: Translator.trans("js.error_message_phoneNumber_format")
            // }],
            // email: [{
            //     required: true,
            //     msg: Translator.trans("js.error_message_representativeform_email_required")
            // },{
            //     minLength: 4,
            //     msg: Translator.trans("js.error_message_representativeform_email_minlength")
            // },{
            //     maxLength: 64,
            //     msg: Translator.trans("js.error_message_representativeform_email_maxlength")
            // },{
            //     pattern: "email",
            //     msg: Translator.trans("js.error_message_email_format")
            // }],
            status: {
                required: true,
                msg: Translator.trans("js.error_message_serviceform_status_required")
            },
        },

        /**
         * Parses the response and returns the appropriate data
         * @param {Object} response The reponse
         * @return {Object} The data
         */
        parse: function(response){

            if( !_.isUndefined(response.data) ){

                return response.data;
            }

            return response;
        }
    });

    z.ProjectsCorporateContractsModel = ProjectsCorporateContractsModel;

})(window.z = window.z || {}, Backbone);
